"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSingleRun = useSingleRun;
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const react_1 = require("react");
function useSingleRun(deps = "") {
    const prevDeps = (0, react_1.useRef)("__null__");
    const prevValue = (0, react_1.useRef)();
    return (func) => {
        if (!(0, fast_deep_equal_1.default)(prevDeps.current, deps)) {
            prevDeps.current = deps;
            prevValue.current = func?.();
        }
        return prevValue.current;
    };
}
